export default "__VITE_ASSET__jzFyYpjh__"